module.exports = __webpack_public_path__ + "static/slide7-318x245-3c863adb7bb0f80eb9ab48b5d3dc73de.gif";